<fgb-page-header [pageTitle]="'games.page.trivia'" [backButtonLink]="'/games'" [showFooter]="false" [showBanner]="false"></fgb-page-header>

<!--Banner-->
<fgb-portal-games-banner [isTriviaPage]="true"></fgb-portal-games-banner>

<div class="container ">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
